<header class="header">
  <div class="page_title_close_btn">
    <app-page-close-button (click)="goBack()"></app-page-close-button>
    <div class="page_title">
      @if (readOnlyMode) {
        View
      } @else if (editingEnabled) {
        Edit
      } @else {
        Add
      }
      Tariff
    </div>
  </div>
  <div class="tabs">
    <div class="tab" (click)="activateTab(1)">
      <div class="page_number_tab_line">
        <div class="page_number" [ngClass]="{'active_tab': activeTab===1}">1</div>
        <div class="tab_line"></div>
      </div>
      Basic Details
    </div>
    <div class="tab" (click)="activateTab(2)">
      <div class="page_number_tab_line">
        <div class="page_number" [ngClass]="{'active_tab': activeTab===2}">2</div>
        <div class="tab_line"></div>
      </div>
      Rule Set Configuration
    </div>
  </div>
  <div class="save_cancel_btn">

    @if (!readOnlyMode) {
      <button class="secondary_button add_new_btn" (click)="goBack()">Cancel</button>
      <button class="primary_button add_new_btn" (click)="saveTariff()">
        <span>
          @if (editingEnabled) {
            Update
          } @else {
            Save
          }
        </span>
      </button>
    } @else {
      <button class="secondary_button add_new_btn" (click)="goBack()">Go Back</button>
    }
  </div>
</header>
<div class="full_page_container" #scrollContainer>
  @if (activeTab === 1) {
    <div class="card">
      <app-dynamic-form [formConfig]="manageTariffFormConfig" [formGroup]="manageTariffForm"></app-dynamic-form>

      <div class="title">Common Criteria</div>
      <div class="divider"></div>
      <div class="common_criteria" (click)="addRulesForCommonCriteria()">+ Add Rules</div>
      <div class="rules-container" *ngIf="commonCriteria.length > 0">
        <div class="rule-pill" *ngFor="let rule of commonCriteria" (click)="addRulesForCommonCriteria()">
          {{ getDisplayTextForDeterminant(rule.determinant) }} {{ getDisplayTextForOperator(rule.operator) }}
          {{ getValuesToPrint(rule) }} <span *ngIf="rule.values.length > 3">...</span>
        </div>
      </div>
    </div>
    @if (showSlabConfig) {
      <div class="card_title">
        <div class="title">
          <div class="main">Slab Configuration <span class="slab_cnt_chip"
                                                     *ngIf="slabConfig.slabSet.length > 0">{{ slabConfig.slabSet.length }}</span>
          </div>
          <div class="sub_title">Add slab configuration for storage days</div>
        </div>
        <button class="btn tertiary_button"
                (click)="addNewSlab()">
          <app-svg-icon [path]="'assets/icons/plus_icon.svg'" style="height: 20px;width: 20px"></app-svg-icon>
          Add Slab Configuration
        </button>
      </div>
      @if (slabConfig.slabSet.length === 0) {
        <div class="card">
          <div class="no_data">
            <app-no-data
              [path]="'assets/images/no_configuration.svg'"
              [msg]="'No Slab Configurations has been added.'"></app-no-data>
            <button class="btn tertiary_button"
                    (click)="addNewSlab()">
              <app-svg-icon [path]="'assets/icons/plus_icon.svg'" style="height: 20px;width: 20px"></app-svg-icon>
              Add Slab Configuration
            </button>
          </div>
        </div>
      } @else {
        <div class="slab_table">
          @for (slabSet of slabConfig.slabSet; track $index) {
            <div class="card">
              <div class="slab_card_content">
                <div class="slab_card_header">
                  Configuration {{ $index + 1 }}
                  <div class="slab_icon">
                    <app-svg-icon [path]="'assets/icons/clone_icon.svg'" class="delete_icon"
                                  style="background: #000000"
                                  (click)=cloneSlab($index)></app-svg-icon>
                  </div>
                  <div class="slab_icon">
                    <app-svg-icon [path]="'assets/icons/delete_icon.svg'" class="delete_icon"
                                  (click)=deleteSlab($index)></app-svg-icon>
                  </div>
                </div>
                <div class="slab_card_body">
                  <div class="common_criteria" (click)="addSlabCriteria($index)">+ Add Slab Criteria</div>
                  <div class="rules-container" *ngIf="slabSet.criteria.rules?.length > 0">
                    <div class="rule-pill" *ngFor="let rule of slabSet.criteria.rules"
                         (click)="addSlabCriteria($index)">
                      {{ getDisplayTextForDeterminant(rule.determinant) }} {{ getDisplayTextForOperator(rule.operator) }}
                      {{ getValuesToPrint(rule) }} <span *ngIf="rule.values.length > 3">...</span>
                    </div>
                  </div>
                  <app-editable-table
                    [tableHeaders]="slabTableConfig"
                    [showInputFieldsOnTh]="false"
                    [(tableData)]="slabSet.slabs"
                    [deletionAllowed]="true"
                    (dataDeleted)="deleteSlabRange($event,$index)"
                  ></app-editable-table>
                  <button class="ghost_button" (click)="addNewSlabRange($index)">Add Slab Range</button>
                </div>
              </div>
            </div>
          }
          <button class="btn tertiary_button"
                  (click)="addNewSlab()">
            <app-svg-icon [path]="'assets/icons/plus_icon.svg'" style="height: 20px;width: 20px"></app-svg-icon>
            Add Slab Configuration
          </button>
        </div>
      }
    }

  } @else if (activeTab === 2) {
    <app-tariff-table
      [(ruleSets)]="ruleSets"
      [determinants]="allDeterminants"
    ></app-tariff-table>
  }
</div>
